"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var EntityTypeMap_1 = __importDefault(require("../entity-store/EntityTypeMap"));

var EntityTypeMapAuditorEvent;

(function (EntityTypeMapAuditorEvent) {
  EntityTypeMapAuditorEvent["Write"] = "Write";
  EntityTypeMapAuditorEvent["Evict"] = "Evict";
})(EntityTypeMapAuditorEvent || (EntityTypeMapAuditorEvent = {}));

var EntityTypeMapAudtior = /*#__PURE__*/function (_EntityTypeMap_1$defa) {
  _inherits(EntityTypeMapAudtior, _EntityTypeMap_1$defa);

  var _super = _createSuper(EntityTypeMapAudtior);

  function EntityTypeMapAudtior(config) {
    var _this;

    _classCallCheck(this, EntityTypeMapAudtior);

    _this = _super.call(this);
    _this.auditLog = config.auditLog;
    return _this;
  }

  _createClass(EntityTypeMapAudtior, [{
    key: "write",
    value: function write(typename, dataId, storeFieldName, variables) {
      this.auditLog.log("Writing to type map", EntityTypeMapAuditorEvent.Write, "EntityTypeMap", {
        typename: typename,
        dataId: dataId,
        storeFieldName: storeFieldName,
        variables: variables
      });
      return _get(_getPrototypeOf(EntityTypeMapAudtior.prototype), "write", this).call(this, typename, dataId, storeFieldName, variables);
    }
  }, {
    key: "evict",
    value: function evict(dataId, storeFieldName) {
      this.auditLog.log("Evicting from type map", EntityTypeMapAuditorEvent.Evict, "EntityTypeMap", {
        dataId: dataId,
        storeFieldName: storeFieldName
      });
      return _get(_getPrototypeOf(EntityTypeMapAudtior.prototype), "evict", this).call(this, dataId, storeFieldName);
    }
  }]);

  return EntityTypeMapAudtior;
}(EntityTypeMap_1.default);

exports.default = EntityTypeMapAudtior;